<template>

	<div class="register-page">


		<!-- 标题 -->
		<div class="center-container">
			<img style="width: 100px; height: 100px;" src="../../public/app_logo.jpg" />
			<p class="title">{{ $t('language000003') }}</p>
		</div>


		<!-- 选择国家 -->
		<div class="select-country-div">
			<label class="select-country-label" for="country">{{ $t('language000004') }}</label>
			<select id="country" v-model="selectedCountry" class="select-country-select">
				<option value="86">+86 China</option>
				<option value="852">+852 Hong Kong -China</option>
				<option value="853">+853 Macau -China</option>
				<option value="886">+886 Taiwan -China</option>
				<option value="1">+1 United States</option>
				<option value="93">+93 Afghanistan</option>
				<option value="355">+355 Albania</option>
				<option value="213">+213 Algeria</option>
				<option value="1684">+1684 American Samoa</option>
				<option value="376">+376 Andorra</option>
				<option value="244">+244 Angola</option>
				<option value="1264">+1264 Anguilla</option>
				<option value="1268">+1268 Antigua and Barbuda</option>
				<option value="54">+54 Argentina</option>
				<option value="374">+374 Armenia</option>
				<option value="297">+297 Aruba</option>
				<option value="61">+61 Australia</option>
				<option value="43">+43 Austria</option>
				<option value="994">+994 Azerbaijan</option>
				<option value="1242">+1242 Bahamas</option>
				<option value="973">+973 Bahrain</option>
				<option value="880">+880 Bangladesh</option>
				<option value="1246">+1246 Barbados</option>
				<option value="375">+375 Belarus</option>
				<option value="32">+32 Belgium</option>
				<option value="501">+501 Belize</option>
				<option value="229">+229 Benin</option>
				<option value="1441">+1441 Bermuda</option>
				<option value="975">+975 Bhutan</option>
				<option value="591">+591 Bolivia</option>
				<option value="387">+387 Bosnia and Herzegovina</option>
				<option value="267">+267 Botswana</option>
				<option value="55">+55 Brazil</option>
				<option value="673">+673 Brunei</option>
				<option value="359">+359 Bulgaria</option>
				<option value="226">+226 Burkina Fas</option>
				<option value="257">+257 Burundi</option>
				<option value="855">+855 Cambodia</option>
				<option value="237">+237 Cameroon</option>
				<option value="1">+1 Canada</option>
				<option value="238">+238 Cape Verde</option>
				<option value="1345">+1345 Cayman Islands</option>
				<option value="236">+236 Central African Republic</option>
				<option value="235">+235 Chad</option>
				<option value="56">+56 Chile</option>
				<option value="57">+57 Colombia</option>
				<option value="269">+269 Comoros</option>
				<option value="682">+682 Cook Islands</option>
				<option value="506">+506 Costa Rica</option>
				<option value="385">+385 Croatia</option>
				<option value="53">+53 Cuba</option>
				<option value="599">+599 Curacao</option>
				<option value="357">+357 Cyprus</option>
				<option value="420">+420 Czech</option>
				<option value="243">+243 Democratic Republic of the Congo</option>
				<option value="45">+45 Denmark</option>
				<option value="253">+253 Djibouti</option>
				<option value="1767">+1767 Dominica</option>
				<option value="1809">+1809 Dominican Republic</option>
				<option value="593">+593 Ecuador</option>
				<option value="20">+20 Egypt</option>
				<option value="503">+503 El Salvador</option>
				<option value="240">+240 Equatorial Guinea</option>
				<option value="291">+291 Eritrea</option>
				<option value="372">+372 Estonia</option>
				<option value="251">+251 Ethiopia</option>
				<option value="298">+298 Faroe Islands</option>
				<option value="679">+679 Fiji</option>
				<option value="358">+358 Finland</option>
				<option value="33">+33 France</option>
				<option value="594">+594 French Guiana</option>
				<option value="689">+689 French Polynesia</option>
				<option value="241">+241 Gabon</option>
				<option value="220">+220 Gambia</option>
				<option value="995">+995 Georgia</option>
				<option value="49">+49 Germany</option>
				<option value="233">+233 Ghana</option>
				<option value="350">+350 Gibraltar</option>
				<option value="30">+30 Greece</option>
				<option value="299">+299 Greenland</option>
				<option value="1473">+1473 Grenada</option>
				<option value="590">+590 Guadeloupe</option>
				<option value="1671">+1671 Guam</option>
				<option value="502">+502 Guatemala</option>
				<option value="224">+224 Guinea</option>
				<option value="245">+245 Guinea-Bissau</option>
				<option value="592">+592 Guyana</option>
				<option value="509">+509 Haiti</option>
				<option value="504">+504 Honduras</option>
				<option value="36">+36 Hungary</option>
				<option value="354">+354 Iceland</option>
				<option value="91">+91 India</option>
				<option value="62">+62 Indonesia</option>
				<option value="98">+98 Iran</option>
				<option value="964">+964 Iraq</option>
				<option value="353">+353 Ireland</option>
				<option value="972">+972 Israel</option>
				<option value="39">+39 Italy</option>
				<option value="225">+225 Ivory Coast</option>
				<option value="1876">+1876 Jamaica</option>
				<option value="81">+81 Japan</option>
				<option value="962">+962 Jordan</option>
				<option value="7">+7 Kazakhstan</option>
				<option value="254">+254 Kenya</option>
				<option value="686">+686 Kiribati</option>
				<option value="965">+965 Kuwait</option>
				<option value="996">+996 Kyrgyzstan</option>
				<option value="856">+856 Laos</option>
				<option value="371">+371 Latvia</option>
				<option value="961">+961 Lebanon</option>
				<option value="266">+266 Lesotho</option>
				<option value="231">+231 Liberia</option>
				<option value="218">+218 Libya</option>
				<option value="423">+423 Liechtenstein</option>
				<option value="370">+370 Lithuania</option>
				<option value="352">+352 Luxembourg</option>
				<option value="389">+389 Macedonia</option>
				<option value="261">+261 Madagascar</option>
				<option value="265">+265 Malawi</option>
				<option value="60">+60 Malaysia</option>
				<option value="960">+960 Maldives</option>
				<option value="223">+223 Mali</option>
				<option value="356">+356 Malta</option>
				<option value="596">+596 Martinique</option>
				<option value="222">+222 Mauritania</option>
				<option value="230">+230 Mauritius</option>
				<option value="269">+269 Mayotte</option>
				<option value="52">+52 Mexico</option>
				<option value="373">+373 Moldova</option>
				<option value="377">+377 Monaco</option>
				<option value="976">+976 Mongolia</option>
				<option value="382">+382 Montenegro</option>
				<option value="1664">+1664 Montserrat</option>
				<option value="212">+212 Morocco</option>
				<option value="258">+258 Mozambique</option>
				<option value="95">+95 Myanmar</option>
				<option value="264">+264 Namibia</option>
				<option value="977">+977 Nepal</option>
				<option value="31">+31 Netherlands</option>
				<option value="687">+687 New Caledonia</option>
				<option value="64">+64 New Zealand</option>
				<option value="505">+505 Nicaragua</option>
				<option value="227">+227 Niger</option>
				<option value="234">+234 Nigeria</option>
				<option value="47">+47 Norway</option>
				<option value="968">+968 Oman</option>
				<option value="92">+92 Pakistan</option>
				<option value="680">+680 Palau</option>
				<option value="970">+970 Palestine</option>
				<option value="507">+507 Panama</option>
				<option value="675">+675 Papua New Guinea</option>
				<option value="595">+595 Paraguay</option>
				<option value="51">+51 Peru</option>
				<option value="63">+63 Philippines</option>
				<option value="48">+48 Poland</option>
				<option value="351">+351 Portugal</option>
				<option value="1787">+1787 Puerto Rico</option>
				<option value="974">+974 Qatar</option>
				<option value="242">+242 Republic Of The Congo</option>
				<option value="262">+262 Réunion Island</option>
				<option value="40">+40 Romania</option>
				<option value="7">+7 Russia</option>
				<option value="250">+250 Rwanda</option>
				<option value="1869">+1869 Saint Kitts and Nevis</option>
				<option value="1758">+1758 Saint Lucia</option>
				<option value="508">+508 Saint Pierre and Miquelon</option>
				<option value="1784">+1784 Saint Vincent and The Grenadines</option>
				<option value="685">+685 Samoa</option>
				<option value="378">+378 San Marino</option>
				<option value="239">+239 Sao Tome and Principe</option>
				<option value="966">+966 Saudi Arabia</option>
				<option value="221">+221 Senegal</option>
				<option value="381">+381 Serbia</option>
				<option value="248">+248 Seychelles</option>
				<option value="232">+232 Sierra Leone</option>
				<option value="65">+65 Singapore</option>
				<option value="1721">+1721 Saint Maarten (Dutch Part)</option>
				<option value="421">+421 Slovakia</option>
				<option value="386">+386 Slovenia</option>
				<option value="677">+677 Solomon Islands</option>
				<option value="252">+252 Somalia</option>
				<option value="27">+27 South Africa</option>
				<option value="82">+82 South Korea</option>
				<option value="34">+34 Spain</option>
				<option value="94">+94 Sri Lanka</option>
				<option value="249">+249 Sudan</option>
				<option value="597">+597 Suriname</option>
				<option value="268">+268 Swaziland</option>
				<option value="46">+46 Sweden</option>
				<option value="41">+41 Switzerland</option>
				<option value="963">+963 Syria</option>
				<option value="992">+992 Tajikistan</option>
				<option value="255">+255 Tanzania</option>
				<option value="66">+66 Thailand</option>
				<option value="670">+670 Timor-Leste</option>
				<option value="228">+228 Togo</option>
				<option value="676">+676 Tonga</option>
				<option value="1868">+1868 Trinidad and Tobago</option>
				<option value="216">+216 Tunisia</option>
				<option value="90">+90 Turkey</option>
				<option value="993">+993 Turkmenistan</option>
				<option value="1649">+1649 Turks and Caicos Islands</option>
				<option value="256">+256 Uganda</option>
				<option value="380">+380 Ukraine</option>
				<option value="971">+971 United Arab Emirates</option>
				<option value="44">+44 United Kingdoms</option>
				<option value="598">+598 Uruguay</option>
				<option value="998">+998 Uzbekistan</option>
				<option value="678">+678 Vanuatu</option>
				<option value="58">+58 Venezuela</option>
				<option value="84">+84 Vietnam</option>
				<option value="1340">+1340 Virgin Islands, British</option>
				<option value="1284">+1284 Virgin Islands, US</option>
				<option value="967">+967 Yemen</option>
				<option value="260">+260 Zambia</option>
				<option value="263">+263 Zimbabwe</option>
			</select>
		</div>

		<!-- 输入电话号码 -->
		<div class="phone-number-div">
			<label class="phone-number-label" for="phoneNumber">{{ $t('language000005') }}</label>
			<input class="phone-number-input" type="tel" id="phoneNumber" v-model="phoneNumber"
				:placeholder="$t('language000006')">
		</div>


		<!-- 输入验证码 -->
		<div class="code-div">
			<label class="code-div-label" for="verificationCode">{{ $t('language000007') }}</label>
			<input class="code-div-input" type="text" id="verificationCode" v-model="verificationCode"
				:placeholder="$t('language000008')">
		</div>


		<!-- 发送验证码 -->
		<div style="text-align: end;">
			<button @click="verifyPhoneNumber(0)" :disabled="countdown > 0" class="send-code-btn">
				{{ countdown > 0 ? $t('language000012', { seconds: countdown }) : $t('language000011') }}
			</button>
			<!-- <button v-if="countdown === 0" @click="verifyPhoneNumber(1)" class="voice-code-btn">语音验证码</button> -->
		</div>

		<!-- 注册 -->
		<div class="register-div">
			<button class="register-button" @click="register">{{ $t('language000049') }}</button>
		</div>


		<!-- 登录 -->
		<p class="login-link">{{$t('language000050')}}<router-link
				to="/download">{{ $t('language000051') }}</router-link></p>


		<!-- 图形验证码 -->
		<el-dialog :title="$t('language000008')" :visible.sync="showModal" width="60%">
			<div>
				<div style="padding: 10px;">
					<img :src="imageBase64" alt="Displayed Image" v-if="imageBase64" />
				</div>
				<input v-model="captcha" style="padding: 5px 10px;" :placeholder="$t('language000008')">
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="closeModal(type)">{{ $t('language000052') }}</el-button>
			</span>
		</el-dialog>


	</div>
</template>


<script>
	import axios from 'axios';
	import 'vant/lib/index.css'; //导入样式
	import Vue from 'vue';

	import {
		Popup
	} from 'vant';
	Vue.use(Popup);

	import ElementUI from 'element-ui'; // 在Vue实例创建之前引入Element UI库
	import 'element-ui/lib/theme-chalk/index.css';
	Vue.use(ElementUI);


	export default {
		name: 'Register',
		mounted() {
			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
		},
		data() {
			return {
				selectedCountry: '86', //选择国家的默认值
				type: '', //0发送短信验证码 1发送语音验证码
				phoneNumber: '', //电话号码
				verificationCode: '', //验证码
				countdown: 0, //发送验证码倒计时
				codeId: 0, //图形验证码ID
				showModal: false, // 控制是否显示提示框
				imageBase64: '', //图形验证码
				captcha: '', // 存储验证码输入

			};
		},
		methods: {
			verifyPhoneNumber(type) { //第一步校验手机号
				this.type = type;
				if (this.phoneNumber.length <= 0) { //判断手机号长度是否为0
					alert(this.language000006)
					return;
				}
				axios.post(this.$p_url + '/feign/userInfo/checkExistPhone_h5', {
						phoneNumber: this.phoneNumber,
						zone: this.selectedCountry
					})
					.then(response => {
						console.log("返回的值：", response.data)
						if (response.data.state === "success") {
							this.getverificationCode(type);
						} else {
							alert("接口失败：" + response.data);
						}
					})
					.catch(error => {
						alert("请求失败：" + error);
					});
			},
			getverificationCode(type) { //第二步 获取图形验证码
				axios.get(this.$p_url + '/feign/sendSMS/getSmsVerificationCode_h5')
					.then(response => {
						console.log("返回的值：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.codeId = response.data.data.codeId //图片验证码ID
							this.imageBase64 = response.data.data.codeImage; //图片验证码

							//加载图形验证码
							const img = new Image(); // 创建新的Image对象
							img.onload = () => { // 当图像加载完成时，将Base64字符串赋值给显示图像的变量
								this.imageBase64 = img.src;
								this.showModal = true; //显示提示框
							};
							img.onerror = (error) => { // 当图像加载失败时，显示错误信息
								console.error('加载图像失败：', error);
							};
							// 将Base64字符串赋值给图像的src属性
							img.src = `data:image/png;base64,${this.imageBase64}`;

						} else { // 处理状态为失败的情况
							alert("接口失败：" + response.data);
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
			},
			closeModal(type) { //确定输入了图形验证码
				this.showModal = false; //隐藏提示框
				if (type == 0) {
					this.sendVerificationCode(); //发送短信验证码
				} else {
					this.sendVoiceCode(); //发送语言验证码
				}
			},
			sendVerificationCode() { //发送短信验证码
				console.log("codeId：", this.codeId)
				console.log("code：", this.captcha)
				axios.post(this.$p_url + '/feign/sendSMS/sendSmsCode_h5', {
						phone: this.phoneNumber, //手机号
						restType: "2",
						type: this.selectedCountry == 86 ? 2 : 3, //2国内 3国际
						zone: this.selectedCountry, //区号
						codeId: this.codeId, //验证码ID
						code: this.captcha, //用户输入的验证码
					})
					.then(response => {
						console.log("返回的值：", response.data)
						if (response.data.state === "success") { // 短信发送成功
							this.startCountdown(); //倒计时

						} else { // 处理状态为失败的情况
							alert("接口失败：" + response.data);
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
				this.captcha = ''; //清空输入的图形验证码
			},
			sendVoiceCode() { //发送语音验证码

			},
			register() { //注册
				if (this.phoneNumber.length <= 0) { //判断手机号长度是否为0
					alert(this.language000006)
					return;
				}

				if (this.verificationCode.length <= 0) { //判断验证码长度是否为0
					alert(this.language000008)
					return;
				}
				axios.post(this.$p_url + '/feign/userInfo/register_h5', {
						country: this.selectedCountry, //区号
						phoneNumber: this.phoneNumber, //手机号
						verificationCode: this.verificationCode //验证码
					})
					.then(response => {
						console.log("返回的值：", response.data)
						if (response.data.state === "success") { // 注册成功

							this.$router.push({ //跳转到下载页面
								name: 'download',
								params: {

								}
							});

						} else { // 处理状态为失败的情况
							alert("接口失败：" + response.data);
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
			},
			startCountdown() {
				this.countdown = 60;
				const timer = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--;
					} else {
						clearInterval(timer);
					}
				}, 1000);
			},
		}
	};
</script>

<style scoped>
	@import '../css/register.css';
	@import url('https://unpkg.com/element-ui/lib/theme-chalk/index.css');
</style>